/**
 * Utilidad rgba para sombras hover en tarjetas de skills.
 * Los degradados y claves de marca viven en `skillBrandGradients.ts`.
 */
export function hexToRgba(hex: string, alpha: number): string {
  let h = hex.replace('#', '').trim();
  if (h.length === 3) {
    h = h
      .split('')
      .map((c) => c + c)
      .join('');
  }
  if (h.length !== 6) {
    return `rgba(51, 65, 85, ${alpha})`;
  }
  const n = parseInt(h, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export {
  resolveSkillGradientKey,
  getCssLinearGradientForText,
  getGradientPreset,
  getGlowColorHex,
  getGlowColorHex as getSkillBrandColor,
  SKILL_GRADIENT_PRESETS,
} from './skillBrandGradients';
